import { render, staticRenderFns } from "./MoveListItem.vue?vue&type=template&id=5be9967c&scoped=true&"
import script from "./MoveListItem.vue?vue&type=script&lang=js&"
export * from "./MoveListItem.vue?vue&type=script&lang=js&"
import style0 from "./MoveListItem.vue?vue&type=style&index=0&id=5be9967c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be9967c",
  null
  
)

export default component.exports